export function selectedRanges(words, selectedIds, include = () => true) {
  const ids = new Set(selectedIds);
  const ranges = [];
  let range = null;
  for (const word of words) {
    if (!ids.has(word.id) || !include(word)) { range = null; continue; }
    if (!range) { range = {start:word.start,end:word.end}; ranges.push(range); }
    else range.end = Math.max(range.end,word.end);
  }
  return ranges;
}
